class ChangeEmailModalCtrl {
    /** @ngInject */
    constructor($state, User, ErrorCatcher) {
        this.$state = $state
        this.User = User
        this.ErrorCatcher = ErrorCatcher
    }

    $onInit() {
        this.currentState = 'state-email-form'
        this.isSending = false
        this.isSubmitted = false
        this.errorMessage = null
        this.form = {
            new_email: null,
            password: null,
        }
    }

    submitEmail() {
        this.isSending = true
        this.User.saveNewEmail(this.form).$promise.then((result) => {
            this.isSubmitted = true
            this.currentState = 'state-finish'
        }).catch((error) => {
            this.ErrorCatcher.catchError(error)
            this.errorMessage = error.data.message
            this.currentState = 'state-error'
        }).finally(() => {
            this.isSending = false
        })
    }

    closeModal() {
        this.close({ $value: { isSubmitted: this.isSubmitted } })
    }
}

export default {
    template: require('./change-email-modal.jade')(),
    controller: ChangeEmailModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
        close: '&', // {$value: myResult}
        dismiss: '&', // {$value: myRejectedResult}
    },
}



// WEBPACK FOOTER //
// ./src/states/personalInformation/modal/change-email-modal.js